import {
  put,
  call,
  take,
  fork,
  select,
  race,
  takeEvery
} from 'redux-saga/effects'
import { delay } from 'redux-saga'
import {
  FETCH_TUTORIAL_LIST,
  FETCH_TUTORIAL_STEPS,
  ANIMATE_STEP,
  ANIMATE_ALL,
  UPDATE_STEP,
  UPDATE_STEP_NB
} from './constants'
import { fetchTutorialListApi, fetchTutorialStepsApi } from './services'
import {
  fetchTutorialList,
  fetchTutorialSteps,
  updateStepFrame,
  updateStepNonBlocking,
  termAllStepAnimation
} from './actions'
import {
  selectAnimationData,
  selectCurrentStep,
  selectButtonData,
  selectIsLastStep
} from './selectors'

function* fetchTutorialListWorker(currentPhoneId) {
  const response = yield call(fetchTutorialListApi, currentPhoneId)

  if (Array.isArray(response.tutorials)) {
    yield put(fetchTutorialList.success(currentPhoneId, response.tutorials))
  }
}

function* fetchTutorialStepsWorker(tutorialId) {
  const response = yield call(fetchTutorialStepsApi, tutorialId)

  if (Array.isArray(response)) {
    yield put(fetchTutorialSteps.success(tutorialId, response))
  }
}

function* animateStepWorker(stepDelay = 500) {
  const state = yield select()
  const animationData = selectAnimationData(state)
  yield call(delay, stepDelay)
  for (let frameIndex = 0; frameIndex < animationData.length; frameIndex++) {
    yield put(updateStepFrame(frameIndex))
    yield call(delay, animationData[frameIndex].delay)
  }
  yield put(updateStepNonBlocking(selectCurrentStep(state) + 1))
}

function* animateAllWorker(stepDelay = 500) {
  const state = yield select()
  if (!selectIsLastStep(state)) {
    yield call(animateStepWorker, stepDelay)
    yield put(updateStepNonBlocking(selectCurrentStep(state) + 1))
    yield call(animateAllWorker, 2500)
  } else {
    yield put(termAllStepAnimation())
  }
}

function* fetchTutorialListWatcher() {
  while (true) {
    const payload = yield take(FETCH_TUTORIAL_LIST.REQUEST)
    yield call(fetchTutorialListWorker, payload.currentPhoneId)
  }
}

function* fetchTutorialStepsWatcher() {
  while (true) {
    const { tutorialId } = yield take(FETCH_TUTORIAL_STEPS.REQUEST)
    yield call(fetchTutorialStepsWorker, tutorialId)
  }
}

function* animateStepWatcher() {
  while (true) {
    yield take(ANIMATE_STEP)
    yield race({
      task: call(animateStepWorker),
      cancel1: take(UPDATE_STEP),
      cancel2: take(FETCH_TUTORIAL_STEPS.REQUEST)
    })
  }
}

function* animateStepHelper() {
  yield takeEvery(UPDATE_STEP_NB, function* animateStepActions() {
    const state = yield select()
    if (
      selectButtonData(state).swipeOrAction.toLowerCase() === 'none' &&
      !selectIsLastStep(state)
    ) {
      yield race({
        task: call(animateStepWorker, 300),
        cancel1: take(UPDATE_STEP),
        cancel2: take(FETCH_TUTORIAL_STEPS.REQUEST)
      })
    }
  })
}

function* animateAllWatcher() {
  while (true) {
    yield take(ANIMATE_ALL)
    yield race({
      task: call(animateAllWorker),
      cancel1: take(UPDATE_STEP),
      cancel2: take(FETCH_TUTORIAL_STEPS.REQUEST)
    })
  }
}

export default function* rootSaga() {
  yield fork(fetchTutorialListWatcher)
  yield fork(fetchTutorialStepsWatcher)
  yield fork(animateStepWatcher)
  yield fork(animateStepHelper)
  yield fork(animateAllWatcher)
}
